<template>
    <div class="container">
      <div class="progress-container">
        <div class="progress" id="progress"></div>
            <div @click="clickProgressCircle('details')" class="circle active"><p class="details">Details</p></div>
            <div @click="clickProgressCircle('confirm')" class="circle"><p class="confirm">Confirm</p></div>
        </div>

        <div class="howContainer" v-show="currentActive === 2">
            <div style="display: none;" class="howContainerInner">
                <ServiceOptions @noAccountProductsForZipCode="noAccountProductsForZipCode($event)" @GetSelectedService="GetSelectedService($event)" @GetSelectedAdditionalService="GetSelectedAdditionalService($event)" :currentActive="currentActive" :noRouteCodeAvailable="noRouteCodeAvailable" :isContractedDeliveryProp="isContractedDelivery" :ServiceOptionsData="ServiceOptionsData" :shipmentData="shipmentData" :customerLocationHasPickupService="customerLocationHasPickupService" :geoCodeDataGraphQLDeliveryPickup="geoCodeDataGraphQLDeliveryPickup" :geoCodeDataGraphQL="geoCodeDataGraphQL"/>
            </div>       
            <div class="inputLabel" style="display: none;">
                <label for="services">Service Type</label>
                <input id="services" type="text" v-model="shipmentData.service">
            </div>
        </div>

        <div class="detailsContainer" v-show="(currentActive === 1)">
            <div class="notifications-container">
                
                <div class="notifications-container-0">
                    <div v-if="!gettingUserPreferences" class="confirmContainerInner1">
                        <div class="confirm-svg">
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                    <g>
                                    <g>
                                        <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                        <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                        <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                        <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                        <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                    </g>
                                    <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                    <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                    <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                    <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                    <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                    <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                    </g>
                                </g>
                            </svg>
                            <h2>Delivery Address</h2>
                        </div>
                        
                        <div class="confirmLabelContainer">
                            <p name="companyName">{{shipmentData.serviceAddress.address.companyName}}</p>
                        </div>
                        
                        <div class="confirmLabelContainer">
                            <p name="address1">{{shipmentData.serviceAddress.address.address1}}</p>
                        </div>
                        
                        <div v-if="shipmentData.serviceAddress.address.address2" class="confirmLabelContainer">
                            <p name="address2">{{shipmentData.serviceAddress.address.address2}}</p>
                        </div>
                        
                        <div class="confirmLabelContainer">
                            <p name="city">{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}}, {{shipmentData.serviceAddress.address.zipCode}}</p>
                        </div>

                        <div v-if="shipmentData.serviceAddress.address.attention" class="confirmLabelContainer">
                            <label>Contact Name:</label>
                            <p style="white-space: nowrap;" name="contactName">{{shipmentData.serviceAddress.address.attention}}</p>
                        </div>
                    </div>
                    <div class="weightMainContainer">
                        <div v-if="shipmentDataArray.length < 1" class="weightInputContainer" id="weightInputContainer">
                            <div class="weightInput">
                                <p>Package 1</p>
                                <div class="weightInputBox">
                                    <label for="weightCheckBox">Less than 1 lb</label>
                                    <input type="radio" id="weightCheckBox" class="weightInputClass" value="1" v-model="weightArray[0]">
                                </div>
                                <label for="shipmentWeight">Weight (lbs)</label>
                                <input name="weight" type="number" id="shipmentWeight" class="weightInputClass" onkeydown="return event.keyCode !== 69" v-model="weightArray[0]">
                            </div>
                        </div>
                        <div v-else v-for="(shipment, index) in shipmentDataArray" :key="index" class="weightInputContainer" id="weightInputContainer">
                            <div class="weightInput">
                                <p>Package {{index + 1}}</p>
                                <div class="weightInputBox">
                                    <label for="weightCheckBox">Less than 1 lb</label>
                                    <input type="radio" id="weightCheckBox" class="weightInputClass" value="1" v-model="weightArray[index]">
                                </div>
                                <label for="shipmentWeight">Weight (lbs)</label>
                                <input name="weight" type="number" id="shipmentWeight" class="weightInputClass" onkeydown="return event.keyCode !== 69" v-model="weightArray[index]">
                            </div>
                            <button v-if="(index > 0) && ((index + 1) == shipmentDataArray.length)" @click="removeShipment()" class="removePackageButton">Remove Package</button>

                        </div>
                    </div>

                </div>
                <div class="notifications-container-1">
                    <!-- Notifications -->
                    <div>
                        <div class="confirm-svg notifications notificationHeader">
                            <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                            <h2>Notifications</h2>
                        </div>
                        <div class="inputLabelNotification">
                            <div class="inputLabelNotificationInner">
                                <label>Delivery</label>

                                <div class="inputButtonContainer">
                                    <input class="notification-input-style" placeholder="Enter Email or Phone" name="delivery" id="deliveryInput" type="text" @input="inputNotify = $event.target.value">
                                    <button type="submit" @click="inputIsValid()" onclick="document.getElementById('deliveryInput').value = '';">Add</button>
                                </div>
                            </div>
                        </div>
                        <div class="emailsAddedContainer" v-if="(shipmentData.notify[0].delivery[0].email.length > 0 || shipmentData.notify[0].delivery[0].phone.length > 0)">
                            <div v-for="(items, index) in shipmentData.notify[0].delivery[0].email" v-bind:key="items" class="addedItems">
                                <p>{{this.shipmentData.notify[0].delivery[0].email[index]}}</p>
                                <button @click="RemoveEmail(index)" class="removeItemButton">Delete</button>
                            </div> 
                            <div v-for="(items, index) in shipmentData.notify[0].delivery[0].phone" v-bind:key="items" class="addedItems">
                                <p>{{this.shipmentData.notify[0].delivery[0].phone[index]}}</p>
                                <button @click="RemovePhone(index)" class="removeItemButton">Delete</button>
                            </div> 
                        </div>
                        <div class="inputLabelNotification">
                            <div class="inputLabelNotificationInner">
                                <label>Non-Delivery</label>

                                <div class="inputButtonContainer">
                                    <input class="notification-input-style" placeholder="Enter Email or Phone" name="nonDelivery" id="nonDeliveryInput" type="text" @input="inputNotifyNonDelivery = $event.target.value">
                                    <button type="submit" @click="inputIsValidNonDelivery()" onclick="document.getElementById('nonDeliveryInput').value = '';">Add</button>
                                </div>
                            </div>
                        </div>
                        <div class="emailsAddedContainer" v-if="(shipmentData.notify[0].nonDelivery[0].email.length > 0 || shipmentData.notify[0].nonDelivery[0].phone.length > 0)">
                            <div v-for="(items, index) in shipmentData.notify[0].nonDelivery[0].email" v-bind:key="items" class="addedItems">
                                <p>{{this.shipmentData.notify[0].nonDelivery[0].email[index]}}</p>
                                <button @click="RemoveNonDelivEmail(index)" class="removeItemButton">Delete</button>
                            </div>  
                            <div v-for="(items, index) in shipmentData.notify[0].nonDelivery[0].phone" v-bind:key="items" class="addedItems">
                                <p>{{this.shipmentData.notify[0].nonDelivery[0].phone[index]}}</p>
                                <button @click="RemoveNonDelivPhone(index)" class="removeItemButton">Delete</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="notifications-container-2">
                    <h2 class="referenceHeader">References</h2>

                    
                            <div class="referenceInputLabel">
                                <label for="addReference">Add Reference:</label>
                                <div class="inputButtonContainer">
                                    <input class="notification-input-style" id="addReference" type="text" placeholder="Add a Reference" @input="referenceValue = $event.target.value" maxlength="50">
                                    <button v-show="showRefCount <= 4" type="submit" @click="addReference()" onclick="document.getElementById('addReference').value = '';">Add</button>
                                </div>
                            </div>

                            <div class="referenceInputLabel" v-show="showRefCount >= 1">
                                <label for="reference1">Reference 1</label>
                                <div class="inputButtonContainer">
                                    <input v-model="shipmentData.ref1" id="reference1" type="text" maxlength="50">
                                </div>
                            </div>
                            
                            <div class="referenceInputLabel" v-show="showRefCount >= 2">
                                <label for="reference2">Reference 2</label>
                                <div class="inputButtonContainer">
                                    <input v-model="shipmentData.ref2" id="reference2" type="text" maxlength="50">
                                </div>
                            </div>
                            
                            <div class="referenceInputLabel" v-show="showRefCount >= 3">
                                <label for="reference3">Reference 3</label>
                                <div class="inputButtonContainer">
                                    <input v-model="shipmentData.ref3" id="reference3" type="text" maxlength="50">
                                </div>
                            </div>
                            
                            <div class="referenceInputLabel" v-show="showRefCount >= 4">
                                <label for="reference4">Reference 4</label>
                                <div class="inputButtonContainer">
                                    <input v-model="shipmentData.ref4" id="reference4" type="text" maxlength="50">
                                </div>
                            </div>
                            
                            <div class="referenceInputLabel" v-show="showRefCount >= 5">
                                <label for="reference5">Reference 5</label>
                                <div class="inputButtonContainer">
                                    <input v-model="shipmentData.ref5" id="reference5" type="text" maxlength="50">
                                </div>
                            </div>

                    <div class="inputLabel">
                        <label for="descriptionref">Description</label>
                        <div class="inputButtonContainer">
                            <input id="descriptionref" type="text" v-model="shipmentData.description" maxlength="50">
                            <button style="display: none">+</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="confirmContainer" v-show="currentActive === 2">
            <div class="confirm-container-main">
                <div class="confirm-header-container">
                    <h1 class="package-details-header">Package Details</h1>
                    <img src="../../assets/LREXDinoFooter.jpg" alt="">
                </div>
                        
                
                <div class="package-details-container">
                    <div>

                    <div class="confirmContainerInner1 create-shipment">
                        <div class="confirm-svg">
                            <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                </g>
                            </svg>
                            <h2>Create Shipment</h2>
                        </div>
                        
                        <div class="buttonContainer">
                            <!-- <button class="saveButton" @click="shipmentData.secretKey = 'secretKey', CreateShipmentLambda()">Save</button> -->
                            <button class="shipButton" @click="CreateShipmentLambda()" type="submit">Ship</button>
                        </div>

                        <div>
                            <p>By clicking Ship I agree to the<span>
                            <a href="/ShippingTC" target="_blank" class="show-terms-conditions-link">
                                terms and conditions.
                            </a>
                            </span>
                            </p>
                        </div>
                    </div>

                    
                    <div class="confirmContainerInner">
                        <div class="confirm-container-address">
                            <div class="confirmContainerInner1">
                                <div class="confirm-svg">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                        <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                            <g>
                                            <g>
                                                <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                                <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                                <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                                <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                                <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                            </g>
                                            <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                            <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                            <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                            <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                            <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                            <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <h2>Delivery Address</h2>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="companyName">{{shipmentData.serviceAddress.address.companyName}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="address1">{{shipmentData.serviceAddress.address.address1}}</p>
                                </div>
                                
                                <div v-if="shipmentData.serviceAddress.address.address2" class="confirmLabelContainer">
                                    <p name="address2">{{shipmentData.serviceAddress.address.address2}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="city">{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}}, {{shipmentData.serviceAddress.address.zipCode}}</p>
                                </div>

                                <div v-if="shipmentData.serviceAddress.address.attention" class="confirmLabelContainer">
                                    <label for="Attention">Contact Name:</label>
                                    <p style="white-space: nowrap;" id="Attention" name="contactName">{{shipmentData.serviceAddress.address.attention}}</p>
                                </div>
                            </div>
                            <div class="confirmContainerInner1">
                                <div class="confirm-svg">
                                        <svg version="1.1" id="Layer_2_00000011015521083262897090000013693107950429558190_"
                                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.6 219.7"
                                                style="enable-background:new 0 0 320.6 219.7;" xml:space="preserve">
                                            <g id="_Ñëîé_1">
                                                <g>
                                                    <g>
                                                        <polyline class="st1" points="59.6,21 93.4,54.7 21,127.6 5,111.7 			"/>
                                                        <path class="st1" d="M101.7,187l1.4,1.2l4.7,4.7c4.6,4.6,5.4,12,1.3,17c-4.7,5.8-13.2,6.1-18.4,1l-22.1-21.7
                                                            c-5-5-9.4-10.6-13-16.6c-5-8.4-8.4-17.7-10.2-27.3L43.1,132l-13.3-13.2"/>
                                                        <path class="st1" d="M106.1,191.2l20,19.9c4.9,4.8,12.7,4.8,17.5-0.1c4.8-4.9,4.8-12.7-0.1-17.5l-1-1l-4.4-4.3l-2.5-2.5"/>
                                                        <path class="st1" d="M144.7,194.8l14,13.9l-0.7-0.7l1.9,1.9c4.9,4.8,12.7,4.8,17.6-0.1c2.7-2.7,3.8-6.3,3.5-9.8
                                                            c-0.2-2.8-1.4-5.6-3.6-7.8l-9.1-8.7"/>
                                                        <path class="st1" d="M85.1,63.1l15.1,14.9l11.4-3.4c12.2-3.7,25.5-1.7,36.1,5.3l51,33.9c2.1,1.4,3,3.7,2.8,6c-0.1,1-0.4,2-1,2.9
                                                            c-5.9,9-18.2,11.3-26.9,5L159,117.4c-1.2-0.8-2.5-1.3-3.8-1.4c-2.4-0.2-4.8,0.7-6.5,2.5c-2.8,3.1-2.7,7.8,0.3,10.8l62,61.6
                                                            c5.2,5.2,4.9,13.8-1,18.6c-5,3.9-12.2,3.2-16.8-1.3l-14.5-14.3"/>
                                                    </g>
                                                    <g>
                                                        <polyline class="st1" points="237.1,206.3 315.6,206.3 315.6,5 115.9,5 115.9,49.6 			"/>
                                                        <g>
                                                            <line class="st1" x1="258.2" y1="177.4" x2="253.3" y2="177.4"/>
                                                            <line class="st1" x1="285.9" y1="177.4" x2="281" y2="177.4"/>
                                                        </g>
                                                    </g>
                                                    <polyline class="st1" points="242.2,5 242.2,55.2 213.6,38.6 185,55.2 185,5 		"/>
                                                </g>
                                            </g>
                                        </svg>
                                        <h2>Pickup Address</h2>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="companyName">{{shipmentData.deliveryPickup.address.companyName}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="address1">{{shipmentData.deliveryPickup.address.address1}}</p>
                                </div>
                                
                                <div v-if="shipmentData.deliveryPickup.address.address2" class="confirmLabelContainer">
                                    <p name="address2">{{shipmentData.deliveryPickup.address.address2}}</p>
                                </div>
                                
                                <div class="confirmLabelContainer">
                                    <p name="city">{{shipmentData.deliveryPickup.address.city}}, {{shipmentData.deliveryPickup.address.state}}, {{shipmentData.deliveryPickup.address.zipCode}}</p>
                                </div>

                                <div v-if="shipmentData.deliveryPickup.address.attention" class="confirmLabelContainer">
                                    <label>Contact Name:</label>
                                    <p style="white-space: nowrap;" id="contactName" name="contactName">{{shipmentData.deliveryPickup.address.attention}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="confirmContainerInner2">
                            <div class="confirm-svg notifications">
                                <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                                <h2>Notifications</h2>
                            </div>
                            
                            <div v-if="shipmentData.deliveryEmail && shipmentData.deliveryEmail.length > 0" class="confirmLabelContainer2">
                                <label>Delivery Email:</label>
                                <div class="notificationArray" name="deliveryemail" v-for="(email, index) in shipmentData.deliveryEmail" :key="index">
                                        <p>{{shipmentData.deliveryEmail[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.deliveryPhone && shipmentData.deliveryPhone.length > 0" class="confirmLabelContainer2">
                                <label>Delivery Phone:</label>
                                <div class="notificationArray" name="deliveryphone" v-for="(email, index) in shipmentData.deliveryPhone" :key="index">
                                        <p>{{shipmentData.deliveryPhone[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.nonDeliveryEmail && shipmentData.nonDeliveryEmail.length > 0" class="confirmLabelContainer2">
                                <label>Non Delivery Email:</label>
                                <div class="notificationArray" name="nonDeliveryemail" v-for="(email, index) in shipmentData.nonDeliveryEmail" :key="index">
                                        <p>{{shipmentData.nonDeliveryEmail[index]}}</p>
                                </div>
                            </div>

                            <div v-if="shipmentData.nonDeliveryPhone && shipmentData.nonDeliveryPhone.length > 0" class="confirmLabelContainer2">
                                <label>Non Delivery Phone:</label>
                                <div class="notificationArray" name="nonDeliveryphone" v-for="(email, index) in shipmentData.nonDeliveryPhone" :key="index">
                                        <p>{{shipmentData.nonDeliveryPhone[index]}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="weight-container">
                        <div v-if="shipmentData.deliveryInstructions" class="confirmLabelContainer">
                            <label style="font-weight: bold; white-space: nowrap;">Delivery Instructions:</label>
                            <p style="text-align: left;" name="DeliveryInstructions">{{shipmentData.deliveryInstructions}}</p>
                        </div>

                        <div class="confirmLabelContainer">
                            <label style="font-weight: bold;">Service:</label>
                            <p name="service">{{shipmentServiceType(shipmentData)}}</p>
                        </div>

                        <div v-if="shipmentData.additionalServices && shipmentData.additionalServices.length > 0" class="confirmLabelContainer">
                            <label style="font-weight: bold; white-space: nowrap;">Additional Services:</label>
                            <div v-for="(additionalService, index) in shipmentData.additionalServices" :key="index">
                                <p style="margin-right: 5px;">{{additionalService}}</p>
                            </div>
                        </div>

                        <div v-if="isContractedDelivery" class="confirmLabelContainer">
                            <p style="font-weight: bold;">Contracted Delivery</p>
                        </div>

                        <div class="confirmLabelContainer" v-for="(shipment, index) in shipmentDataArray" :key="index">
                            <label style="font-weight: bold; white-space: nowrap;">Package {{index + 1}} Weight:</label>
                            <p name="weight" v-if="shipment.weight == 1">Less than 1(lb)</p>
                            <p v-else name="weight">{{shipment.weight}} (lbs)</p>
                        </div>
                    </div>

                    </div>

                    <div>

                        <div v-if="currentActive === 2" class="weight-container">
                            <div class="legend-header-container">
                                <div class="confirm-svg">
                                    <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
                                        <g id="image">
                                            <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
                                        </g>
                                    </svg>
                                    <h2>Address Locations</h2>
                                </div>
                                <div class="map-legend-container">
                                    <div class="map-legend">
                                        <svg display="block" height="31px" width="17px" viewBox="0 0 27 41"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="#33f18a"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#000000" opacity="0.25" cx="5.5" cy="5.5" r="5.4999962"></circle><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="5.4999962"></circle></g></g></svg>
                                        <p>Pickup Address <span v-show="!shipmentData.deliveryPickup.address.longitude">Map Unavailable</span></p>
                                    </div>
                                    <div class="map-legend">
                                        <svg display="block" height="31px" width="17px" viewBox="0 0 27 41"><g fill-rule="nonzero"><g transform="translate(3.0, 29.0)" fill="#000000"><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="10.5" ry="5.25002273"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="9.5" ry="4.77275007"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="8.5" ry="4.29549936"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="7.5" ry="3.81822308"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="6.5" ry="3.34094679"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="5.5" ry="2.86367051"></ellipse><ellipse opacity="0.04" cx="10.5" cy="5.80029008" rx="4.5" ry="2.38636864"></ellipse></g><g fill="#32ccfe"><path d="M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"></path></g><g opacity="0.25" fill="#000000"><path d="M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"></path></g><g transform="translate(6.0, 7.0)" fill="#FFFFFF"></g><g transform="translate(8.0, 8.0)"><circle fill="#000000" opacity="0.25" cx="5.5" cy="5.5" r="5.4999962"></circle><circle fill="#FFFFFF" cx="5.5" cy="5.5" r="5.4999962"></circle></g></g></svg>
                                        <p>Delivery Address <span v-show="!shipmentData.serviceAddress.address.longitude">Map Unavailable</span></p>
                                    </div>
                                </div>
                            </div>
                            <LocationMap :showPickupLogic="true" :shipmentData="shipmentData"/>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <div class="finalContainer" v-show="currentActive === 3">

            <h1>Thank you for choosing LRex!</h1>
           
            <div v-if="(shippingLabelArray.length > 0) && showPdfRenderer">
                <pdf-label-renderer :urls="this.shippingLabelArray" :hideBarcode="hideBarcode"/>
            </div>

            <p class="pdfSupportMessage">*Your browser may not support embedded PDF's use button above to open in new tab.</p>
            <div class="shipped-page">
            <div class="confirm-container-main">
                <div class="confirmContainerInner">
                    <div class="confirm-container-address">
                        <div class="confirmContainerInner1">
                            <div class="confirm-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                            <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                            <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                            <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                            <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                        </g>
                                        <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                        <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                        <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                        <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                        <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                        <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                        </g>
                                    </g>
                                </svg>
                                <h2>Delivery Address</h2>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="companyName">{{shipmentData.serviceAddress.address.companyName}}</p>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="address1">{{shipmentData.serviceAddress.address.address1}}</p>
                            </div>
                            
                            <div v-if="shipmentData.serviceAddress.address.address2" class="confirmLabelContainer">
                                <p name="address2">{{shipmentData.serviceAddress.address.address2}}</p>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="city">{{shipmentData.serviceAddress.address.city}}, {{shipmentData.serviceAddress.address.state}}, {{shipmentData.serviceAddress.address.zipCode}}</p>
                            </div>

                            <div v-if="shipmentData.serviceAddress.address.attention" class="confirmLabelContainer">
                                <label>Contact Name:</label>
                                <p style="white-space: nowrap;" name="contactName">{{shipmentData.serviceAddress.address.attention}}</p>
                            </div>
                        </div>
                        <div class="confirmContainerInner1">
                            <div class="confirm-svg">
                                    <svg version="1.1" id="Layer_2_00000011015521083262897090000013693107950429558190_"
                                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 320.6 219.7"
                                            style="enable-background:new 0 0 320.6 219.7;" xml:space="preserve">
                                        <g id="_Ñëîé_1">
                                            <g>
                                                <g>
                                                    <polyline class="st1" points="59.6,21 93.4,54.7 21,127.6 5,111.7 			"/>
                                                    <path class="st1" d="M101.7,187l1.4,1.2l4.7,4.7c4.6,4.6,5.4,12,1.3,17c-4.7,5.8-13.2,6.1-18.4,1l-22.1-21.7
                                                        c-5-5-9.4-10.6-13-16.6c-5-8.4-8.4-17.7-10.2-27.3L43.1,132l-13.3-13.2"/>
                                                    <path class="st1" d="M106.1,191.2l20,19.9c4.9,4.8,12.7,4.8,17.5-0.1c4.8-4.9,4.8-12.7-0.1-17.5l-1-1l-4.4-4.3l-2.5-2.5"/>
                                                    <path class="st1" d="M144.7,194.8l14,13.9l-0.7-0.7l1.9,1.9c4.9,4.8,12.7,4.8,17.6-0.1c2.7-2.7,3.8-6.3,3.5-9.8
                                                        c-0.2-2.8-1.4-5.6-3.6-7.8l-9.1-8.7"/>
                                                    <path class="st1" d="M85.1,63.1l15.1,14.9l11.4-3.4c12.2-3.7,25.5-1.7,36.1,5.3l51,33.9c2.1,1.4,3,3.7,2.8,6c-0.1,1-0.4,2-1,2.9
                                                        c-5.9,9-18.2,11.3-26.9,5L159,117.4c-1.2-0.8-2.5-1.3-3.8-1.4c-2.4-0.2-4.8,0.7-6.5,2.5c-2.8,3.1-2.7,7.8,0.3,10.8l62,61.6
                                                        c5.2,5.2,4.9,13.8-1,18.6c-5,3.9-12.2,3.2-16.8-1.3l-14.5-14.3"/>
                                                </g>
                                                <g>
                                                    <polyline class="st1" points="237.1,206.3 315.6,206.3 315.6,5 115.9,5 115.9,49.6 			"/>
                                                    <g>
                                                        <line class="st1" x1="258.2" y1="177.4" x2="253.3" y2="177.4"/>
                                                        <line class="st1" x1="285.9" y1="177.4" x2="281" y2="177.4"/>
                                                    </g>
                                                </g>
                                                <polyline class="st1" points="242.2,5 242.2,55.2 213.6,38.6 185,55.2 185,5 		"/>
                                            </g>
                                        </g>
                                    </svg>
                                    <h2>Pickup Address</h2>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="companyName">{{shipmentData.deliveryPickup.address.companyName}}</p>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="address1">{{shipmentData.deliveryPickup.address.address1}}</p>
                            </div>
                            
                            <div v-if="shipmentData.deliveryPickup.address.address2" class="confirmLabelContainer">
                                <p name="address2">{{shipmentData.deliveryPickup.address.address2}}</p>
                            </div>
                            
                            <div class="confirmLabelContainer">
                                <p name="city">{{shipmentData.deliveryPickup.address.city}}, {{shipmentData.deliveryPickup.address.state}}, {{shipmentData.deliveryPickup.address.zipCode}}</p>
                            </div>

                            <div v-if="shipmentData.deliveryPickup.address.attention" class="confirmLabelContainer">
                                <label>Contact Name:</label>
                                <p style="white-space: nowrap;" name="contactName">{{shipmentData.deliveryPickup.address.attention}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="confirmContainerInner2">
                        <div class="confirm-svg notifications">
                            <svg data-name="Livello 1" viewBox="10 12.5 40 40" xmlns="http://www.w3.org/2000/svg"><path d="M1 33A32 32 0 1 0 33 1 32 32 0 0 0 1 33Z" fill="none" class="fill-000000"></path><rect height="24.18" rx="1.48" ry="1.48" width="32" x="17" y="21" stroke-miterlimit="10" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></rect><path d="M48.44 21.83 37.53 33.54a6.27 6.27 0 0 1-9.07 0l-10.9-11.7M39.19 31.75l8.96 12.76M26.98 31.88 17.7 44.51" stroke-linejoin="round" fill="none" stroke="#000" stroke-width="2px" class="stroke-ffffff"></path></svg>
                            <h2>Notifications</h2>
                        </div>
                        
                        <div v-if="shipmentData.deliveryEmail && shipmentData.deliveryEmail.length > 0" class="confirmLabelContainer2">
                            <label>Delivery Email:</label>
                            <div class="notificationArray" name="deliveryemail" v-for="(email, index) in shipmentData.deliveryEmail" :key="index">
                                    <p>{{shipmentData.deliveryEmail[index]}}</p>
                            </div>
                        </div>

                        <div v-if="shipmentData.deliveryPhone" class="confirmLabelContainer2">
                            <label>Delivery Phone:</label>
                            <div class="notificationArray" name="deliveryphone" v-for="(email, index) in shipmentData.deliveryPhone" :key="index">
                                    <p>{{shipmentData.deliveryPhone[index]}}</p>
                            </div>
                        </div>

                        <div v-if="shipmentData.nonDeliveryEmail && shipmentData.nonDeliveryEmail.length > 0" class="confirmLabelContainer2">
                            <label>Non Delivery Email:</label>
                            <div class="notificationArray" name="nonDeliveryemail" v-for="(email, index) in shipmentData.nonDeliveryEmail" :key="index">
                                    <p>{{shipmentData.nonDeliveryEmail[index]}}</p>
                            </div>
                        </div>

                        <div v-if="shipmentData.nonDeliveryPhone" class="confirmLabelContainer2">
                            <label>Non Delivery Phone:</label>
                            <div class="notificationArray" name="nonDeliveryphone" v-for="(email, index) in shipmentData.nonDeliveryPhone" :key="index">
                                    <p>{{shipmentData.nonDeliveryPhone[index]}}</p>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="weight-container">
                        <div v-if="shipmentData.deliveryInstructions" class="confirmLabelContainer">
                            <label style="font-weight: bold; white-space: nowrap;">Delivery Instructions:</label>
                            <p style="text-align: left;" name="DeliveryInstructions">{{shipmentData.deliveryInstructions}}</p>
                        </div>

                        <div class="confirmLabelContainer">
                            <label style="font-weight: bold;">Service:</label>
                            <p name="service">{{shipmentServiceType(shipmentData)}}</p>
                        </div>

                        <div v-if="isContractedDelivery" class="confirmLabelContainer">
                            <p style="font-weight: bold;">Contracted Delivery</p>
                        </div>

                        <div v-if="shipmentData.additionalServices && shipmentData.additionalServices.length > 0" class="confirmLabelContainer">
                            <label style="font-weight: bold; white-space: nowrap;">Additional Services:</label>
                            <div v-for="(additionalService, index) in shipmentData.additionalServices" :key="index">
                                <p style="margin-right: 5px;">{{additionalService}}</p>
                            </div>
                        </div>
                        
                        <div class="confirmLabelContainer" v-for="(shipment, index) in shipmentDataArray" :key="index">
                            <label style="font-weight: bold; white-space: nowrap;">Package {{index + 1}} Weight:</label>
                            <p name="weight" v-if="shipment.weight == 1">Less than 1(lb)</p>
                            <p v-else name="weight">{{shipment.weight}} (lbs)</p>
                        </div>
                    </div>
                </div>
                </div>
            <div>
                <button class="refreshButton" @click="refreshPage()">Create Another Shipment</button>
            </div>
        </div>
      <button v-show="((currentActive <= 4) && (showPickupLogic == false)) || ((currentActive <= 5) && (showPickupLogic == true))" class="btn" id="prev" disabled @click="stepPrev()">Prev</button>
      <button v-show="((currentActive <= 4) && (showPickupLogic == false)) || ((currentActive <= 5) && (showPickupLogic == true))" class="btn" id="next" @click="checkInputAdded()">Next</button>
    </div>
    
    <AlertUser v-if="toggleCustomAddressWarning" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/> 
    <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
    <div v-if="creatingLabels">
        <LoadingData :headerMessage="headerMessage"/>
    </div>
    <div v-if="gettingUserPreferences">
        <LoadingData :headerMessage="headerMessage"/>
    </div>
</template>


<script>
import {Auth, API} from 'aws-amplify';
import {shippingQuoteP2P, createShipmentLREX} from "../../graphql/mutations";
import AlertUser from '../../components/Popups/AlertUser.vue';
import LocationMap from './../AWSLocation/LocationMap.vue';
import LoadingData from '../../components/Popups/LoadingData.vue';
import ServiceOptions from '../../components/ShipmentCenter/ServiceOptions.vue';
import PdfLabelRenderer from './../ShipmentDashboard/PdfLabelRenderer.vue'

export default {
    components:{
        AlertUser,
        LoadingData,
        ServiceOptions,
        LocationMap,
        PdfLabelRenderer
    },
    data(){
        return{
            pdfUrls: [
                "https://lb8z0vd7m7.execute-api.us-east-1.amazonaws.com/dev/shipmentlabel/24735627/1796322563517/c6c588ceb787b4db959793cc6c4ad11e6e6c77c16564d61271cc235f63703b21/24735627.pdf",
                "https://lb8z0vd7m7.execute-api.us-east-1.amazonaws.com/dev/shipmentlabel/24735628/1796322584176/becd63118dc9fbb1369f91b050b5a414fcae2d8839ab13fba82c98a1aba61de2/24735628.pdf"
            ],
            addToAddressBookToggle: false,
            showPickupLogic: false,
            showPdfRenderer: false,
            placeHolder: "Search for Address",
            showPDF: false,
            creatingLabels: false,
            referenceValue: '',
            showRefCount: 0,
            inputNotify: '',
            inputNotifyNonDelivery: '',
            currentActive: 1,
            circles: [],
            progress: [],
            weight: [],
            user: {},
            dataReturn: {},
            shipmentDataArray: [],
            deliveryWindowStart: "",
            deliveryWindowEnd: "",
            deliveryWindowLabel: "",
            shipmentData:{
                secretKey: '',
                service: '',
                totalPrice: '',
                serviceAddress: {
                    address: {
                    companyName: '',
                    attention: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    phone: '',
                    phoneExt: '',
                    relevance: '',
                    latitude: '',
                    longitude: '',
                    routeCode: ''
                    }
                },
                deliveryPickup: {
                    address: {
                    companyName: '',
                    attention: '',
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    zipCode: '',
                    phone: '',
                    phoneExt: '',
                    relevance: '',
                    latitude: '',
                    longitude: '',
                    routeCode: ''
                    }
                },
                product: [],
                isContractedDelivery: false,
                isPickup: false,
                shipmentID: 0,
                ref1: '',
                ref2: '',
                ref3: '',
                ref4: '',
                ref5: '',
                description: '',
                deliveryInstructions: '',
                weight: 1.0,
                additionalServices: [
                    ''
                ],
                timeWindow: '',
                deliveryEmail: [],
                deliveryPhone: [],
                nonDeliveryEmail: [],
                nonDeliveryPhone: [],
                notify: [
                    {
                    delivery: 
                    [
                        {
                            email: [
                                
                            ],
                            phone: [
                                
                            ]
                        }
                    ],
                    nonDelivery: [
                        {
                        email: [
                            
                        ],
                        phone: [
                            
                        ]
                        }
                    ]
                    }
                ]
            },
            shipmentLabel:{
                shipmentID: [],
                labelFormat: "PDF",
                multipleLabelPerSheet: false
            },
            shipmentLabelTiff:{
                shipmentID: [],
                labelFormat: "TIFF",
                multipleLabelPerSheet: true
            },
            addressBookToggle: false,
            toggleAlertBox: false,
            toggleContractedDeliveryLocation: false,
            toggleCustomAddressWarning: false,
            toggleAddressInputContainer: false,
            userEnterCustomAddress: false,
            alertMessage: 'Error Message',
            selectedAddress: "",
            headerMessage: "",
            gettingUserPreferences: false,
            userCustomAddress: "",
            userCustomAddressPickup: "",
            checkUserCustomAddress: "",
            checkUserCustomAddressPickup: "",
            editAddressSelected: false,
            createShipmentLambdaReturnArray: [],
            jsReportDataObject: {shipmentLabelData: []},
            userDataGraphQL: {},
            accountDataGraphQL: {},
            ServiceOptionsData: {},
            geoCodeDataGraphQL: {},
            geoCodeDataGraphQLDeliveryPickup: {},
            SelectedAdditionalServices: [],
            addressBookData: [],
            items: `items{
                id
                address1
                address2
                city
                state
                zipCode
                companyName
                attention
                email
                phone
                deliveryInstructions
                latitude
                longitude
                relevance
            }`,
            loadingTable: false,
            filterField: null,
            filterValue: null,
            weightArray: [1],
            totalCostArray: [],
            isContractedDelivery: false,
            noRouteCodeAvailable: false,
            customerLocationHasPickupService: false,
            p2pLabelArray: [],
            getCost: false,
            shippingLabelArray: [],
            loadedPDFs: [],
            isContractedCustomer: false,
            showContractedInput: false,
            SearchOutsideContract: false,
            addressBookItemUpdate: {
                id: '',
                address1: '',
                address2: '',
                city: '',
                state: '',
                zipCode: '',
                latitude: '',
                longitude: '',
                relevance: ''
            },
            noPickupProduct: false,
            noPickupProductOnZipCode: false
        }
    },
    beforeMount(){
        Auth.currentAuthenticatedUser().then(user => {
            this.user = user;
            this.token = user.signInUserSession.accessToken.jwtToken;
            if(this.user.signInUserSession.idToken.payload['cognito:groups']){
                this.user.signInUserSession.idToken.payload['cognito:groups'].forEach((group)=>{
                    if(group == 'SearchOutsideContract'){
                        this.SearchOutsideContract = true;
                    }
                })
            }
            this.GetUserGraphQL();
        }).catch(error => {
          if(error){
            this.$router.push('Login');
            Auth.signOut({global: false})
          }
        });
    },
    computed: {
        hideBarcode() {
            return this.shipmentData?.service === 'pickup';
        }
    },
    watch:{
        'shipmentData.serviceAddress.address.zipCode': function(){
            if(this.shipmentData.serviceAddress.address.zipCode.length >= 5){
                this.GetGeoCodeGraphQL();
            }
        },
        'shipmentData.deliveryPickup.address.zipCode': function(){
            if(this.shipmentData.deliveryPickup.address.zipCode.length >=5){
                this.GetGeoCodeGraphQLDeliveryPickup();
            }
        }
    },
    mounted(){
        this.currentActive = 1;
        //Sign user out when JWT expires
        setTimeout(() => {Auth.signOut({global: false})}, 3600000);
        //Step Progress Bar
        this.circles = document.querySelectorAll(".circle");
        const actives = document.querySelectorAll(".active");
        if(actives.length > 1){
            actives[1].classList.remove("active")
        }
        const progress = document.getElementById("progress");
        progress.style.width = "0%";
        //Remove map info from URL
        window.location.hash = ""
    },
    methods:{
        noAccountProductsForZipCode(event){
            console.log("noAccountProductsForZipCode " + event)
            this.noRouteCodeAvailable = true;
        },
        async GetSelectedAdditionalService(selectedService){
            this.totalCostArray = []
            this.shipmentData.totalPrice = "0";
            let servicePrice = selectedService.price + selectedService.additionalServicePrice;
            this.shipmentData.product = selectedService.product.concat(selectedService.additionalServiceProduct)
            this.SelectedAdditionalServices = selectedService.AdditionalServices;
            this.shipmentData.additionalServices = this.SelectedAdditionalServices;
            this.shipmentData.deliveryWindowEnd = selectedService.deliveryWindowEnd;
            this.shipmentData.deliveryWindowStart = selectedService.deliveryWindowStart;
            this.shipmentData.deliveryWindowLabel = selectedService.deliveryWindowLabel;
            // this.shipmentData.isPickup = selectedService.isPickup;
            this.shipmentData.totalPrice = servicePrice.toString();
        },
        GetSelectedService(selectedService){
            this.getCost = selectedService.getCost;
            this.totalCostArray = [];
            this.shipmentData.totalPrice = "0";
            //Service is productFamily
            this.shipmentData.service = selectedService.Service;
            this.shipmentData.isPickup = selectedService.isPickup;
            //Combine all services into product attribute
            this.shipmentData.product = selectedService.product.concat(selectedService.additionalServiceProduct)
            //if(this.isContractedDelivery == false){
            this.shipmentData.serviceAddress.address.routeCode = selectedService.routeCode;
            //}
        },
        clickProgressCircle(circleType){
                const circleMap = {
                    details: 1,
                    confirm: 2
                };

                // Set currentActive based on the circleType
                let clickedCircleMapValue = circleMap[circleType];

                if(clickedCircleMapValue > this.currentActive){
                    this.checkInputAdded()
                }

                if(clickedCircleMapValue < this.currentActive){
                    let currentDifference = this.currentActive - clickedCircleMapValue;
                    for (let i = 0; i < currentDifference; i++) {
                        this.stepPrev();
                    }
                }
            
        },
        onPdfLoad(index) {
            // Mark the PDF as loaded
            this.loadedPDFs[index] = true;
        },
        shipmentServiceType(shipment){
            if(shipment.service == "SSLRLOC"){
                return "Standard"
            }else if(shipment.service == "PSLRLOC"){
                return "Priority"
            }else if(shipment.service == "SSLRPICK"){
                return "Pickup"
            }else{
                return shipment.service
            }
        },
        isUserAuthenticated(){
            Auth.currentAuthenticatedUser().then(user => {
                if(user){
                    localStorage.setItem('userAuthenticated', true);
                    this.authState = 'signedin';
                    this.username = user.username;
                }
            }).catch(error => {
                if(error){
                    localStorage.setItem('userAuthenticated', false);
                    Auth.signOut({global: false})
                }
            });
        },
        async CreateShipmentLambdaInputFinal(){
            await this.createFinalArray();
            for(let i = 0; i < this.shipmentDataArray.length; i++){
                let input  = {
                    username: this.user.username,
                    shipmentID: 0,
                    accountNo: this.userDataGraphQL.accountNo,
                    totalPrice: this.shipmentDataArray[i].totalPrice.toString(),
                    totalCost: this.totalCostArray[i] ?? "0",
                    serviceAddress: {address: {address1: this.shipmentDataArray[i].serviceAddress.address.address1, address2: this.shipmentDataArray[i].serviceAddress.address.address2, city: this.shipmentDataArray[i].serviceAddress.address.city, state: this.shipmentDataArray[i].serviceAddress.address.state, zipCode: this.shipmentDataArray[i].serviceAddress.address.zipCode, phone: this.shipmentDataArray[i].serviceAddress.address.phone, companyName: this.shipmentDataArray[i].serviceAddress.address.companyName, attention: this.shipmentDataArray[i].serviceAddress.address.attention, addressbookAdd: false, phoneExt: this.shipmentDataArray[i].serviceAddress.address.phoneExt, relevance: this.shipmentDataArray[i].serviceAddress.address.relevance, latitude: this.shipmentDataArray[i].serviceAddress.address.latitude, longitude: this.shipmentDataArray[i].serviceAddress.address.longitude, routeCode: this.shipmentDataArray[i].serviceAddress.address.routeCode}},
                    deliveryInstructions: this.shipmentDataArray[i].deliveryInstructions,
                    deliveryWindowStart: this.shipmentDataArray[i].deliveryWindowStart,
                    deliveryWindowEnd: this.shipmentDataArray[i].deliveryWindowEnd,
                    deliveryWindowLabel: this.shipmentDataArray[i].deliveryWindowLabel,
                    isContractedDelivery: this.isContractedDelivery,
                    isPickup: this.shipmentDataArray[i].isPickup,
                    description: this.shipmentDataArray[i].description,
                    ref1: this.shipmentDataArray[i].ref1,
                    ref2: this.shipmentDataArray[i].ref2,
                    ref3: this.shipmentDataArray[i].ref3,
                    ref4: this.shipmentDataArray[i].ref4,
                    ref5: this.shipmentDataArray[i].ref5,
                    service: this.shipmentDataArray[i].service,
                    weight: this.weightArray[i],
                    product: this.shipmentDataArray[i].product,
                    secretKey: this.shipmentDataArray[i].secretKey,
                    additionalServices: this.shipmentDataArray[i].additionalServices,
                    deliveryPhone: this.shipmentDataArray[i].deliveryPhone,
                    deliveryEmail: this.shipmentDataArray[i].deliveryEmail,
                    nonDeliveryPhone: this.shipmentDataArray[i].nonDeliveryPhone,
                    nonDeliveryEmail: this.shipmentDataArray[i].nonDeliveryEmail,
                    notify: {delivery: this.shipmentDataArray[i].notify[0].delivery[0], nonDelivery: this.shipmentDataArray[i].notify[0].nonDelivery[0]},
                    deliveryPickup: {address: {address1: this.shipmentDataArray[i].deliveryPickup.address.address1, address2: this.shipmentDataArray[i].deliveryPickup.address.address2, city: this.shipmentDataArray[i].deliveryPickup.address.city, state: this.shipmentDataArray[i].deliveryPickup.address.state, zipCode: this.shipmentDataArray[i].deliveryPickup.address.zipCode, phone: this.shipmentDataArray[i].deliveryPickup.address.phone, companyName: this.shipmentDataArray[i].deliveryPickup.address.companyName, attention: this.shipmentDataArray[i].deliveryPickup.address.attention,  addressbookAdd: false, phoneExt: this.shipmentDataArray[i].deliveryPickup.address.phoneExt, relevance: this.shipmentDataArray[i].deliveryPickup.address.relevance, latitude: this.shipmentDataArray[i].deliveryPickup.address.latitude, longitude: this.shipmentDataArray[i].deliveryPickup.address.longitude, routeCode: this.shipmentDataArray[i].deliveryPickup.address.routeCode}}
                }
                this.shipmentDataArray[i] = input;
            }
        },
        async CreateShipmentLambda() {
            try {
                this.showPdfRenderer = false;
                await this.CreateShipmentLambdaInputFinal();
                this.scrollToTop();
                this.creatingLabels = true;
                this.headerMessage = "Creating Shipment";
                this.shippingLabelArray = [];
                this.showPDF = false;
                this.loadedPDFs = [];

                for (let shipment of this.shipmentDataArray) {
                    try {
                        let response = await API.graphql({
                            query: createShipmentLREX,
                            variables: { input: shipment },
                            authMode: "AMAZON_COGNITO_USER_POOLS",
                        });

                        let shipmentData = response?.data?.createShipmentLREX;
                        if (!shipmentData?.shipmentID) {
                            throw new Error("Unable to create shipment.");
                        }

                        this.shipmentLabel.shipmentID.push(shipmentData.shipmentID);
                        this.shipmentLabelTiff.shipmentID.push(shipmentData.shipmentID);
                        this.shippingLabelArray.push(shipmentData.labelURL);
                        this.loadedPDFs.push(false);
                        this.showPDF = true;
                    } catch (error) {
                        console.error("Shipment creation error:", error);

                        this.alertMessage = error?.errors?.[0]?.message || "Error creating shipment.";
                        this.toggleAlertBox = true;
                        this.currentActive = 1;
                        this.creatingLabels = false;
                        this.showPDF = false;
                        this.loadedPDFs = [];
                        return; // Stop execution on error
                    }
                }

                this.currentActive = 3;
                this.showPdfRenderer = true;

                if(this.addToAddressBookToggle){
                    await this.createAddressBookItem();
                }
            } catch (error) {
                console.error("CreateShipmentLambda error:", error);
                this.alertMessage = "Unexpected error during shipment creation.";
                this.toggleAlertBox = true;
            } finally {
                this.creatingLabels = false;
                this.scrollToTop();
            }
        },
        scrollToTop(){
            window.scrollTo(0,0);
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
            this.toggleCustomAddressWarning = toggleAlertBox;
            // this.showTermsConditions = toggleAlertBox;
        },
        refreshPage(){
            window.location.reload();
        },
        //Check user input when 'next' button is clicked
        async checkInputAdded(){
            switch(true){
                case ((this.currentActive == 1)):{
                    
                    if(this.noPickupProduct){
                        this.alertMessage = "Your account does not have pickup service. Contact customer support for more information.";
                        this.toggleAlertBox = true;
                        this.scrollToTop();
                        break;
                    }

                    if(this.noPickupProductOnZipCode){
                        this.alertMessage = "No pickup products are available for the provided zip code. Contact customer support for more information.";
                        this.toggleAlertBox = true;
                        this.scrollToTop();
                        break;
                    }

                    if(this.noRouteCodeAvailable){
                        this.alertMessage = "This location does not have pick up service available. Contact customer support for more information.";
                        this.toggleAlertBox = true;
                        this.scrollToTop();
                        break;
                    }

                    let deliveryNotifInput = document.getElementById("deliveryInput").value;
                    let nonDeliveryNotifInput = document.getElementById("nonDeliveryInput").value;
                    let referenceAddInput = document.getElementById("addReference").value;
                    //Check Delivery Input
                    if(deliveryNotifInput != ""){
                        this.inputIsValid();
                        document.getElementById('deliveryInput').value = '';
                    }else if(!(this.shipmentData.notify[0].delivery[0].email.length > 0 || this.shipmentData.notify[0].delivery[0].phone.length > 0)){
                        // this.alertMessage = "You did not add delivery notification contact information.";
                        // this.toggleAlertBox = true;
                        this.scrollToTop();
                    }

                    //Check Non-Delivery Input
                    if(nonDeliveryNotifInput != ""){
                        this.inputIsValidNonDelivery();
                        document.getElementById('nonDeliveryInput').value = '';
                    }else if(!(this.shipmentData.notify[0].nonDelivery[0].email.length > 0 || this.shipmentData.notify[0].nonDelivery[0].phone.length > 0)){
                        // this.alertMessage = "You did not add delivery notification contact information.";
                        // this.toggleAlertBox = true;
                        this.scrollToTop();
                    }

                    //Check/Add Reference Input
                    if(referenceAddInput != ""){
                        this.addReference();
                        document.getElementById('addReference').value = '';
                    }

                    //Check Weight Input
                    let weightIsValid = false;
                    this.weightArray.forEach(element => {
                        if((element.length === 0) || (!element) || (element == "") || (element == null) || (element == undefined)){
                            this.alertMessage = "Please enter a valid weight.";
                            this.toggleAlertBox = true;
                            this.scrollToTop();
                            weightIsValid = false;
                        }else{
                            weightIsValid = true;
                        }
                    });

                    if(weightIsValid){
                        if(this.shipmentDataArray.length > 0){
                            if(this.shipmentDataArray.length != this.weightArray.length){
                                this.alertMessage = "Please enter a valid weight.";
                                this.toggleAlertBox = true;
                                this.scrollToTop();
                                weightIsValid = false;
                            }else{
                                if (this.getCost) {
                                    const serviceNetwork = this.shipmentData.product[0].serviceNetwork;
                                    if (serviceNetwork === "P2PLAX" || serviceNetwork === "P2PJFK") {
                                        await this.createFinalArray();
                                        await this.getShippingQuoteP2P();
                                    }
                                }
                                await this.CreateShipmentLambdaInputFinal()
                                
                                this.stepNext();
                            }
                        }

                        if(this.shipmentDataArray.length == 0){
                            if(this.weightArray.length == 0){
                                this.alertMessage = "Please enter a valid weight.";
                                this.toggleAlertBox = true;
                                this.scrollToTop();
                                weightIsValid = false;
                            }else{
                                if (this.getCost) {
                                    const serviceNetwork = this.shipmentData.product[0].serviceNetwork;
                                    if (serviceNetwork === "P2PLAX" || serviceNetwork === "P2PJFK") {
                                        await this.createFinalArray();
                                        await this.getShippingQuoteP2P();
                                    }
                                }
                                await this.CreateShipmentLambdaInputFinal()
                                
                                this.stepNext();
                            }
                        }
                    }else{
                        this.alertMessage = "Please enter a valid weight.";
                        this.toggleAlertBox = true;
                        weightIsValid = false;
                        this.scrollToTop();
                    }

                    break;
                }

                case ((this.currentActive == 2)):{
                    console.log(this.shipmentData)
                    console.log(this.currentActive)
                    if(this.shipmentData.service.length == 0){
                        this.alertMessage = "Your account does not have pickup service. Contact customer support for more information.";
                        this.toggleAlertBox = true;
                        this.scrollToTop();
                        break;
                    }

                    break;
                }
            }
        },
        //Add Reference
        addReference(){
            this.showRefCount++
            switch(this.showRefCount){
                case 1:{
                    this.shipmentData.ref1 = this.referenceValue;
                    break;
                }
                case 2:{
                    this.shipmentData.ref2 = this.referenceValue;
                    break;
                }
                case 3:{
                    this.shipmentData.ref3 = this.referenceValue;
                    break;
                }
                case 4:{
                    this.shipmentData.ref4 = this.referenceValue;
                    break;
                }
                case 5:{
                    this.shipmentData.ref5 = this.referenceValue;
                    break;
                }
            }
        },
        //Validate Notification Input
        inputIsValid(){
            if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.inputNotify) == true){
                this.shipmentData.notify[0].delivery[0].email.push(this.inputNotify);
                this.shipmentData.deliveryEmail.push(this.inputNotify)
            }else if(/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(this.inputNotify) == true){
                let trimPhone = this.inputNotify.replace(/[^0-9]/g, '');
                //let trimPhoneDashes = trimPhone.slice(0,3)+"-"+trimPhone.slice(3,6)+"-"+trimPhone.slice(6);
                this.shipmentData.notify[0].delivery[0].phone.push(trimPhone);
                this.shipmentData.deliveryPhone.push(trimPhone)
            }
            else{
                this.alertMessage = "Please enter a valid email or phone number.";
                this.toggleAlertBox = true;
            }
        },
        inputIsValidNonDelivery(){
            if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.inputNotifyNonDelivery) == true){
                this.shipmentData.notify[0].nonDelivery[0].email.push(this.inputNotifyNonDelivery);
                this.shipmentData.nonDeliveryEmail.push(this.inputNotifyNonDelivery);
            }else if(/^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(this.inputNotifyNonDelivery) == true){
                let trimPhone = this.inputNotifyNonDelivery.replace(/[^0-9]/g, '');
                //let trimPhoneDashes = trimPhone.slice(0,3)+"-"+trimPhone.slice(3,6)+"-"+trimPhone.slice(6);
                this.shipmentData.notify[0].nonDelivery[0].phone.push(trimPhone)
                this.shipmentData.nonDeliveryPhone.push(trimPhone)
            }
            else{
                this.alertMessage = "Please enter a valid email or phone number.";
                this.toggleAlertBox = true;
            }
        },
        cleanAndValidatePhoneNumber(inputPhoneNumber) {
            // Remove all non-digit characters from the input phone number
            const cleanedPhoneNumber = inputPhoneNumber.replace(/\D/g, '');

            // Check if the cleaned phone number is exactly 10 digits
            if(cleanedPhoneNumber.length == 0){
                return true;
            }else if(cleanedPhoneNumber.length !== 10) {
                return false; // Invalid phone number
            }else{
                if((this.currentActive == 3) && (this.showPickupLogic == true)){
                    this.shipmentData.deliveryPickup.address.phone = cleanedPhoneNumber;
                    return true;
                }else{
                    this.shipmentData.serviceAddress.address.phone = cleanedPhoneNumber;
                    return true;
                }
                
            }
        },
        //Step Circle Progress Bar
        stepPrev(){
            // this.customerLocationHasPickupService = false;
            this.scrollToTop();
            this.currentActive--;
        
            if(this.currentActive < 1){
                this.currentActive = 1;
            }
            this.stepUpdate();
        },
        stepUpdate(){
            const prev = document.getElementById("prev")
            const next = document.getElementById("next")
            const progress = document.getElementById("progress")
            const actives = document.querySelectorAll(".active");

            this.circles.forEach((circle, index)=>{
                switch(true){
                    case((this.currentActive == 1) && (index <= 1)):{
                        circle.classList.add("active");
                        actives[1].classList.remove("active");
                        progress.style.width = "0%";
                        prev.disabled = true;
                        next.disabled = false;
                        break;
                    }
                    case((this.currentActive == 2) && (index <= 2)):{
                        circle.classList.add("active");
                        progress.style.width = "100%";
                        next.disabled = true;
                        prev.disabled = false;
                        break;
                    }
                    default:{
                        circle.classList.remove("active");
                        break;
                    }
                }
            });
        },
        stepNext(){
            this.isUserAuthenticated();
            this.scrollToTop();
            if(this.showPickupLogic == false){
                this.currentActive++;
                if(this.currentActive > this.circles.length){
                    this.currentActive = this.circles.length;
                }
                this.stepUpdate();
                this.scrollToTop();
            }else{
                this.currentActive++;
                if(this.currentActive > this.circles.length){
                    this.currentActive = this.circles.length;
                }
                this.stepUpdate();
                this.scrollToTop();
            }
        },
        //Adding Shipment Weight
        removeShipment(){
            this.shipmentDataArray.pop();
            this.weightArray.pop();
            this.totalCostArray.pop();
        },
        updateShipmentArray(){
            this.shipmentDataArray[0] = this.shipmentData;
            this.shipmentDataArray.push(this.shipmentData)
        },
        async createFinalArray(){
            this.shipmentDataArray = []
            for(let i = 0; i < this.weightArray.length; i++){
                this.shipmentDataArray.push(this.shipmentData)
            }
        },
        //Email-Phone Array Creation 
        RemoveEmail(index){
            this.shipmentData.notify[0].delivery[0].email.splice(index, 1)
            this.shipmentData.deliveryEmail.splice(index, 1)
        },
        RemovePhone(index){
            this.shipmentData.notify[0].delivery[0].phone.splice(index, 1)
            this.shipmentData.deliveryPhone.splice(index, 1)
        },
        RemoveNonDelivEmail(index){
            this.shipmentData.notify[0].nonDelivery[0].email.splice(index, 1)
            this.shipmentData.nonDeliveryEmail.splice(index, 1)
        },
        RemoveNonDelivPhone(index){
            this.shipmentData.notify[0].nonDelivery[0].phone.splice(index, 1)
            this.shipmentData.nonDeliveryPhone.splice(index, 1)
        },
        async getShippingQuoteP2P(){
        this.creatingLabels = true;
        this.headerMessage = "Getting Shipping Cost";

        for (let i = 0; i < this.shipmentDataArray.length; i++) {
            try {
                const response = await API.graphql({
                    query: shippingQuoteP2P,
                    variables: {
                        input: {
                            OriginCity: this.shipmentDataArray[i].deliveryPickup.address.city,
                            OriginStateOrProvince: this.shipmentDataArray[i].deliveryPickup.address.state,
                            OriginPostalCode: this.shipmentDataArray[i].deliveryPickup.address.zipCode,
                            DestinationCity: this.shipmentDataArray[i].serviceAddress.address.city,
                            DestinationStateOrProvince: this.shipmentDataArray[i].serviceAddress.address.state,
                            DestinationPostalCode: this.shipmentDataArray[i].serviceAddress.address.zipCode,
                            Weight: this.weightArray[i].toString(),
                        },
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                this.totalCostArray[i] = response.data.shippingQuoteP2P.shippingQuote;
            } catch (e) {
                console.log(e);
                this.alertMessage = "Unable to get shipping cost.";
                this.toggleAlertBox = true;
            }
        }
            this.creatingLabels = false;
        },
        async SetUserAddress(userAddress){
            let newUserAddress = {};
            Object.entries(userAddress).forEach(entry =>{
                let key = entry[0];
                let value = entry[1];

                if(value == null){
                    newUserAddress[key] = "";
                }else{
                    newUserAddress[key] = value;
                }
            })

            this.shipmentData.deliveryPickup.address = newUserAddress;
            this.GetGeoCodeGraphQLDeliveryPickup()
            // this.shipmentData.deliveryPickup.address.routeCode = "";
        },
        //Check for null values/null causes issues on rest api
        async SetServiceAddress(){
            let newUserAddress = {};
            Object.entries(this.shipmentData.serviceAddress.address).forEach(entry =>{
                let key = entry[0];
                let value = entry[1];

                if(value == null){
                    newUserAddress[key] = "";
                }else{
                    newUserAddress[key] = value;
                }
            })
            console.log("SET ADDRESS", newUserAddress)
            this.shipmentData.serviceAddress.address = newUserAddress;
        },
        async GetUserGraphQL(){
            try {
                this.gettingUserPreferences = true;
                this.headerMessage = "Getting User Data";
                let userData = await API.graphql({
                    query: `query GetUser($userName: String!){
                        getUser(userName: $userName){
                        userName
                        accountNo
                        fullname
                        locationID
                        userEmail
                        nonDeliveryEmail
                        nonDeliveryPhone
                        deliveryPhone
                        deliveryEmail
                        ref1
                        deliveryInstructions
                        locationAddress{
                        labelImage
                        serviceAddress{
                            address{
                                companyName
                                attention
                                address1
                                address2
                                city
                                state
                                zipCode
                                phone
                                phoneExt
                                relevance
                                latitude
                                longitude
                                routeCode
                            }
                        }
                        }
                    }
                    }`,
                    variables: {
                            userName: this.user.username
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.userDataGraphQL = userData.data.getUser;
                await this.SetUserAddress(this.userDataGraphQL.locationAddress.serviceAddress.address)
                await this.GetAccountGraphQL();
                this.shipmentData.deliveryEmail = [...(this.userDataGraphQL?.deliveryEmail ?? [])];
                this.shipmentData.deliveryPhone = [...(this.userDataGraphQL?.deliveryPhone ?? [])];
                this.shipmentData.nonDeliveryEmail = [...(this.userDataGraphQL?.nonDeliveryEmail ?? [])];
                this.shipmentData.nonDeliveryPhone = [...(this.userDataGraphQL?.nonDeliveryPhone ?? [])];

                if(this.userDataGraphQL?.ref1 !== undefined && this.userDataGraphQL?.ref1 !== null){
                    this.showRefCount = 1;
                    this.shipmentData.ref1 = this.userDataGraphQL?.ref1 ?? "";
                }

                this.shipmentData.notify[0].delivery[0].email = [...this.shipmentData.deliveryEmail];
                this.shipmentData.notify[0].delivery[0].phone = [...this.shipmentData.deliveryPhone];
                this.shipmentData.notify[0].nonDelivery[0].email = [...this.shipmentData.nonDeliveryEmail];
                this.shipmentData.notify[0].nonDelivery[0].phone = [...this.shipmentData.nonDeliveryPhone];
                if(this.shipmentData.deliveryInstructions == ""){
                    this.shipmentData.deliveryInstructions = this.userDataGraphQL?.deliveryInstructions ?? "";
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.gettingUserPreferences = false;
            }
        },
        async GetAccountGraphQL(){
            try {
                this.gettingUserPreferences = true;
                this.headerMessage = "Getting Account Data";
                let accountData = await API.graphql({
                    query: `query GetAccount($accountNo: String!) {
                        getAccount(accountNo: $accountNo) {
                            accountNo
                            accountType
                            contact1
                            contact2
                            contact3
                            defaultWeight
                            balance
                            creditLimit
                            billable
                            contractedLocations
                            specialPricing
                            billRunDate
                            billFrequency
                            industry

                            product {
                            productCode
                            serviceCode
                            description
                            additionalService
                            serviceNetwork
                            vendor
                            price
                            productName
                            restServiceCode
                            descriptionUI
                            deliveryWindowEnd
                            deliveryWindowStart
                            deliveryWindowLabel
                            productFamily
                            serviceGroup
                            serviceGroupSequence
                            productSequence
                            fuelSurchargeCode
                            useTaxCode
                            getCost
                            }

                            billingAddress {
                            companyName
                            attention
                            address1
                            address2
                            city
                            state
                            zipCode
                            phone
                            phoneExt
                            email
                            relevance
                            latitude
                            longitude
                            routeCode
                            }

                            locationID
                            locationAddress {
                            id
                            accountNo
                            labelImage
                            isContractedPickup
                            isCustomerPickup
                            isContractedDelivery
                            isDefaultLocation
                            isUser
                            placeID
                            placePickupTime
                            routeCode
                            primeRxLocation
                            canManifest
                            createdAt
                            updatedAt
                            owner

                            serviceAddress {
                                address {
                                address1
                                address2
                                attention
                                city
                                companyName
                                latitude
                                longitude
                                relevance
                                routeCode
                                state
                                zipCode
                                }
                            }
                            }

                            billType
                            fuelSurcharge {
                            fuelSurchargeCode
                            fuelSurchargeRate
                            specialRate
                            }

                            cardOnFileCount
                            stripeID
                            paymentMethods
                            defaultPaymentMethodType
                            invoiceEmails
                            paymentDays
                            createdAt
                            updatedAt
                        }
                        }`,
                    variables: {
                            accountNo: this.userDataGraphQL.accountNo
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.accountDataGraphQL = accountData.data.getAccount;

                console.log("ACCOUNT DATA", accountData.data.getAccount.product)
                const pickupOnly = accountData.data.getAccount.product.filter(
                    item => item.productFamily === 'pickup'
                );
                accountData.data.getAccount.product = pickupOnly;
                this.ServiceOptionsData = accountData.data.getAccount;

                if(this.accountDataGraphQL.contractedLocations){
                    this.isContractedCustomer = true;
                    this.showContractedInput = true;
                }
                this.shipmentData.serviceAddress.address.address1 = this.accountDataGraphQL.locationAddress.serviceAddress.address.address1 || "";
                this.shipmentData.serviceAddress.address.address2 = this.accountDataGraphQL.locationAddress.serviceAddress.address.address2 || "";
                this.shipmentData.serviceAddress.address.city = this.accountDataGraphQL.locationAddress.serviceAddress.address.city || "";
                this.shipmentData.serviceAddress.address.state = this.accountDataGraphQL.locationAddress.serviceAddress.address.state || "";
                this.shipmentData.serviceAddress.address.zipCode = this.accountDataGraphQL.locationAddress.serviceAddress.address.zipCode || "";
                this.shipmentData.serviceAddress.address.companyName = this.accountDataGraphQL.locationAddress.serviceAddress.address.companyName || "";
                this.shipmentData.serviceAddress.address.latitude = this.accountDataGraphQL.locationAddress.serviceAddress.address.latitude || "";
                this.shipmentData.serviceAddress.address.longitude = this.accountDataGraphQL.locationAddress.serviceAddress.address.longitude || "";
                this.shipmentData.serviceAddress.address.relevance = this.accountDataGraphQL.locationAddress.serviceAddress.address.relevance || "";
                this.shipmentData.serviceAddress.address.routeCode = this.accountDataGraphQL.locationAddress.serviceAddress.address.routeCode || "";

                if(pickupOnly.length == 0){
                    this.alertMessage = "Your account does not have pickup service. Contact customer support for more information.";
                    this.toggleAlertBox = true;
                    this.scrollToTop();
                    this.noPickupProduct = true;
                }else{ 
                    this.noPickupProduct = false;
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.gettingUserPreferences = false;
            }
        },
        async GetGeoCodeGraphQL(){
            try {
                this.gettingUserPreferences = true;
                this.headerMessage = "Getting GeoCode Data";
                let query = `query listGeoServiceNetworks{
                        listGeoServiceNetworks(geoCode:"${this.shipmentData.serviceAddress.address.zipCode}"){
                            items{
                                geoCode
                                routeCode
                                serviceNetwork
                            }
                        }
                    }`
                let geoCodeData = await API.graphql({
                    query: query,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                // console.log(geoCodeData)
                if(geoCodeData.data.listGeoServiceNetworks.items.length == 0){
                    this.toggleAlertBox = true;
                    this.alertMessage = "LREX does not provide service to this area"
                    if(this.showPickupLogic == false){
                        this.shipmentData.service = "";
                    }
                    this.noRouteCodeAvailable = true;
                    return;
                }else{
                    if(this.showPickupLogic == false){
                        this.shipmentData.service = "";
                    }
                    this.noRouteCodeAvailable = false;
                    this.geoCodeDataGraphQL = geoCodeData.data.listGeoServiceNetworks.items;
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.gettingUserPreferences = false;
            }
        },
        async GetGeoCodeGraphQLDeliveryPickup(){
            try {
                this.gettingUserPreferences = true;
                this.headerMessage = "Getting GeoCode Data";
                let query = 
                `query listGeoServiceNetworks{
                    listGeoServiceNetworks(geoCode:"${this.shipmentData.deliveryPickup.address.zipCode}"){
                        items{
                            geoCode
                            routeCode
                            serviceNetwork
                        }
                    }
                }`

                let geoCodeData = await API.graphql({
                    query: query,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                if(geoCodeData.data.listGeoServiceNetworks.items == null){
                    this.toggleAlertBox = true;
                    this.alertMessage = "No route code available"
                    let obj = this.shipmentData.deliveryPickup.address;
                    for (const key in obj) {
                        if (Object.prototype.hasOwnProperty.call(obj, key)) {
                            obj[key] = '';
                        }
                    }
                    this.noRouteCodeAvailable = true;
                    return;
                }else{
                    this.noRouteCodeAvailable = false;
                    this.geoCodeDataGraphQLDeliveryPickup = geoCodeData.data.listGeoServiceNetworks.items //getGeoCodes;
                    const pickupGeoCodeRoute = this.geoCodeDataGraphQLDeliveryPickup.filter(geoCodeItem => geoCodeItem.serviceNetwork === 'LRPICK');
                    if(pickupGeoCodeRoute.length > 0){
                        if(this.currentActive == 1){
                            this.customerLocationHasPickupService = true;
                        }
                        // this.customerLocationHasPickupService = true;
                        this.shipmentData.deliveryPickup.address.routeCode = pickupGeoCodeRoute[0].routeCode;
                    }else{
                        this.customerLocationHasPickupService = false;
                        if(((this.currentActive == 1)) && (this.shipmentData.deliveryPickup.address.zipCode.length >= 5)){
                            this.toggleAlertBox = true;
                            this.alertMessage = "No pickup products are available for the provided zip code. Contact customer support for more information.";
                            this.currentActive = 1;
                            this.noPickupProductOnZipCode = true;
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }finally{
                this.gettingUserPreferences = false;
            }
        }
    }
}
</script>

<style scoped>
    body {
	overflow-x: hidden;
	margin: 0
}

h2,
h3 {
	width: 100%;
	text-align: center;
	border-radius: 5px;
	padding-top: 5px;
	padding-bottom: 5px
}

.confirm,
.details,
.how,
.where {
	font-size: 1.1rem
}

.container {
	text-align: center;
	width: fit-content;
	min-width: 70%;
	display: block;
	margin: auto;
	box-shadow: rgb(0 0 0 / 20%) 0 5px 15px;
	padding: 10px;
	border-radius: 25px
}

.progress-container {
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 100%;
	margin-top: 15px
}

.progress-container::before {
	content: "";
	background-color: #bdbdbd;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 6px;
	width: 100%;
	z-index: -1;
	transition: .9s ease
}

.progress {
	background-color: #33f18a;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 6px;
	width: 0%;
	z-index: -1;
	transition: .9s ease
}

.circle {
	background-color: #fff;
	color: #999;
	border-radius: 50%;
	height: 70px;
	width: 70px;
	border: 4px solid #b2bec3;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: .9s ease;
	cursor: pointer
}

.circle.active {
	border-color: #33f18a;
	background-color: #33f18a;
	transition-delay: .3s;
	color: #000
}

.circle.active:hover {
	border-color: #30db7d;
	background-color: #30db7d
}

.btn {
	background-color: #33f18a;
	color: #fff;
	border-radius: 6px;
	border: 0;
	cursor: pointer;
	padding: 8px 30px;
	margin: 15px
}

.btn:active {
	transform: scale(.97)
}

.btn:disabled {
	background-color: #bdbdbd;
	cursor: not-allowed
}

.responsive-table {
	width: 100%
}

* {
	scrollbar-width: auto;
	scrollbar-color: #f3f3f3 #fff
}

::-webkit-scrollbar {
	width: 16px
}

::-webkit-scrollbar-track {
	background: #fff
}

::-webkit-scrollbar-thumb {
	background-color: #f3f3f3;
	border-radius: 10px;
	border: 3px solid #fff
}

.table-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #32ccfe;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px;
	color: #fff
}

.table-row-container {
	max-height: 350px;
	overflow-y: auto;
	border-radius: 5px;
	width: 100%;
	animation: animate-table-row 1s ease
}

@keyframes animate-table-row {
	from {
		margin-left: -50px
	}

	to {
		margin-left: 0
	}
}

.table-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #f3f3f3;
	margin-bottom: 10px;
	padding: 5px;
	border-radius: 5px
}

.table-header .col-1 {
	margin-right: 5px
}

.col-1 {
	flex-basis: 20%;
	text-align: left;
	min-width: 30%;
	margin-right: 5px
}

.col-2 {
	flex-basis: 40%;
	text-align: left;
	margin-left: 5px
}

.col-3 {
	flex-basis: 30%;
	text-align: left;
	margin-left: 5px
}

.col-data {
	text-align: left
}

.col-4 {
	flex-basis: 10%;
	text-align: center;
	display: flex;
	justify-content: center;
	align-items: center
}

.service-text {
	background-color: #d4d4d4;
	padding: 2.5px 10px;
	border-radius: 999px;
	width: fit-content;
	margin: 0;
	font-size: 12px
}

.shipmentid-text {
	margin: 0;
	color: #6a6a6a;
	width: fit-content;
	padding: 2.5px 10px;
	border-radius: 999px;
	background-color: #f3f3f3;
	border: 1px solid #a0a0a0;
	transition-duration: .5s
}

.shipmentid-text:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.weightInput {
	animation: weightAnimate;
	animation-duration: .5s;
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-start;
	padding-top: 10px
}

.weightInput label {
	padding-bottom: 2px;
	padding-left: 5%;
	width: 100%;
	text-align: left
}

.weightInput input {
	width: 60%;
	margin-left: 5%
}

.addPackageButton {
	background-color: #33f18a;
	border: none;
	padding: 2px 5px;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	color: #fff;
	transition-duration: .5s;
	margin-top: 10px
}

.addPackageButton:hover {
	background-color: #30df9c;
	transition-duration: .5s
}

.removePackageButton {
	background-color: #32ccfe;
	border: 2px solid #32ccfe;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 5px;
	border-radius: 5px;
	cursor: pointer;
	color: #fff;
	transition-duration: .5s;
	margin-top: 10px
}

.weightMainContainer {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	margin-left: 15%;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 25px;
	width: 70%;
	padding-bottom: 20px
}

.weightMainContainer p {
	font-weight: 700;
	background-color: #32ccfe;
	border-radius: 5px;
	padding: 5px;
	margin-right: 20%;
	margin-left: 20%;
	text-align: center;
	color: #fff
}

@keyframes weightAnimate {
	from {
		margin-top: -10px;
		opacity: 0
	}

	to {
		margin-top: 0;
		opacity: 1
	}
}

.address-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between
}

.address-container-1 {
	width: 50%;
	animation: containerAnimateLeft .4s
}

.address-book-button-container {
	width: 100%
}

.address-book-button-inner {
	width: 20%;
	padding-right: 10px;
	display: flex;
	justify-content: flex-start
}

.my-addresses-button {
	background-color: #33f18a;
	box-shadow: rgba(0, 0, 0, .068) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	transition-duration: .5s;
	border: none;
	color: #fff;
	margin-top: 5px;
	margin-bottom: 5px;
	padding: 5px 5px 5px 5px;
	white-space: nowrap;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row
}

.my-addresses-button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.get-label-button{
    background-color: #33f18a;
	box-shadow: rgba(0, 0, 0, .068) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	transition-duration: .5s;
	border: none;
	color: #fff;
	margin-top: 5px;
	margin-bottom: 5px;
    margin-left: 5px;
	padding: 5px 5px 5px 5px;
	white-space: nowrap;
}

.get-label-button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.contracted-toggle{
    background-color: #e4e4e4;
	box-shadow: rgba(0, 0, 0, .068) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	transition-duration: .5s;
	border: none;
	color: #000;
	margin-bottom: 5px;
	padding: 5px 5px 5px 5px;
	white-space: nowrap;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row
}

.contracted-toggle:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.contracted-locations {
	background-color: #32ccfe
}

.address-book-svg {
	height: 20px;
	margin-right: 3px
}

.ship-to-me-button {
	background-color: #32ccfe;
	box-shadow: rgba(0, 0, 0, .068) 0 1px 5px;
	border-radius: 50px;
	cursor: pointer;
	transition-duration: .5s;
	border: none;
	color: #fff;
	margin-top: 5px;
	margin-bottom: 5px;
	margin-left: 5px;
	padding: 5px 5px 5px 5px;
	white-space: nowrap
}

.ship-to-me-button:hover {
	filter: brightness(.9);
	cursor: pointer;
	transition-duration: .5s
}

.address-container-2 {
	width: 50%;
	animation: containerAnimateRight .4s
}

.address-container-2.pickup-page {
	width: 45%;
	margin: 5px;
	padding: 10px;
	animation: containerAnimateRight .4s
}

.swap-button-container {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 5px
}

.swap-button-inner {
	cursor: pointer;
	background-color: #33f18a;
	border-radius: 999px;
	height: 50px;
	width: 50px;
	transition: .5s
}

.swap-button-inner:hover {
	background-color: #2ed67a;
	transition: .5s
}

@keyframes containerAnimateRight {
	from {
		margin-right: -50px;
		opacity: 0
	}

	to {
		margin-right: 0;
		opacity: 1
	}
}

@keyframes containerAnimateLeft {
	from {
		margin-left: -50px;
		opacity: 0
	}

	to {
		margin-left: 0;
		opacity: 1
	}
}

.notifications-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between
}

.notifications-container-0 {
	width: 33%;
	animation: containerAnimateLeft .4s
}

.weightInputBox {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	width: fit-content;
	padding-left: 5%;
	padding-bottom: 15px
}

.weightInputBox label {
	padding: 0;
	white-space: nowrap
}

.weightInputBox input {
	margin: 0;
	padding: 0;
	cursor: pointer
}

.notifications-container-1 {
	width: 33%;
	animation: containerAnimateLeft .4s
}

.notifications-container-2 {
	width: 33%;
	animation: containerAnimateRight .4s
}

.notificationHeader {
	text-align: left;
	margin: 0;
	margin-left: 8%
}

.referenceHeader {
	text-align: left;
	margin: 0;
	margin-left: 8%;
	padding-top: 0
}

.confirm-container-main {
	margin-top: 15px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: fit-content;
	overflow-x: auto;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 25px;
	animation: containerAnimateLeft .4s
}

.confirm-header-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 15px 15px 0 15px;
	justify-content: space-between
}

.confirm-header-container img {
	width: 40px;
	margin-right: 15px
}

.legend-header-container {
	display: flex;
	align-items: center;
	justify-content: space-between
}

.map-legend-container {
	display: flex;
	flex-direction: column;
	width: fit-content;
	padding: 5px;
	border-radius: 25px;
	background-color: #f5f5f5;
	margin-bottom: 5px
}

.map-legend {
	display: flex;
	flex-direction: row;
	align-items: center
}

.map-legend p {
	margin-left: 5px
}

.weight-container {
	background-color: #fff;
	margin-left: 15px;
	margin-right: 15px;
	margin-bottom: 15px;
	padding: 10px;
	overflow-x: scroll;
	border-radius: 25px;
	box-shadow: rgb(0 0 0 / 16%) 0 1px 10px;
	width: fit-content
}

.weight-container label {
	margin-right: 5px
}

.package-details-container {
	display: flex;
	flex-direction: row
}

.confirmContainerInner {
	text-align: left;
	margin-left: 15px;
	margin-top: 15px;
	margin-bottom: 15px;
	margin-right: 15px
}

.confirmContainerInner-shipped {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	padding: 10px;
	margin-bottom: 10px
}

.shipped-page {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	flex-direction: column;
	margin-bottom: 10px
}

.create-shipment {
	margin-left: 15px;
	margin-right: 15px;
	margin-top: 15px;
	max-width: fit-content
}

.confirmContainerInner1 {
	background-color: #f5f5f5;
	margin-bottom: 15px;
	margin-right: 15px;
	padding: 10px;
	border-radius: 25px;
	box-shadow: rgb(0 0 0 / 16%) 0 1px 10px
}

.confirmContainerInner1 h2 {
	margin: 0;
	text-align: left;
	white-space: nowrap
}

.notifications {
	background-color: #f5f5f5
}

.confirm-svg {
	display: flex;
	flex-direction: row;
	align-items: center;
	background-color: #e4e4e4;
	border-radius: 999px;
	padding: 5px;
	width: fit-content
}

.confirm-svg svg {
	width: 35px;
	height: 35px;
	padding-right: 5px
}

.confirm-svg h2 {
	margin: 0
}

.confirm-container-address {
	display: flex;
	flex-direction: row
}

.package-details-header {
	background-color: #32ccfe;
	color: #fff;
	padding: 10px;
	border-radius: 50px;
	width: fit-content;
	margin: 0
}

.confirmContainerInner2 {
	background-color: #fff;
	padding: 10px;
	border-radius: 25px;
	box-shadow: rgb(0 0 0 / 16%) 0 1px 10px
}

.confirmContainer {
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center
}

.confirmContainerInner label {
	background-color: transparent;
	border: none;
	padding: 0;
	margin-right: 10px;
	font-weight: 700;
	white-space: nowrap
}

.confirmLabelContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	height: auto
}

.confirmLabelContainer p {
	margin-top: 5px;
	margin-bottom: 5px
}

.address-book-add{
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
    justify-content: space-between;
}

.confirmLabelContainer2 {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	padding-bottom: 5px
}

.confirmContainerInner2 h2 {
	text-align: left;
	margin-top: 0;
	margin-bottom: 0
}

.notificationArray p {
	display: flex;
	flex-direction: column;
	margin: 2px
}

.inputLabel {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 5px;
	margin-right: 10%
}

.input-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	margin-bottom: 10px;
	width: 95%
}

.label-choice-container{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 5px;
}

.label-choice-container  label{
    margin-right: 5px;
}

.input-container-input {
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0;
	margin-left: auto;
	width: 50%
}

.char-counter {
  font-size: 0.6rem;
  color: #555;
}

.aws-search-address-container {
	width: 100%
}

.referenceInputLabel {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 5px;
	margin-right: 10%;
	animation: referenceAnimation 1s ease
}

@keyframes referenceAnimation {
	from {
		margin-top: -5%;
		opacity: 0
	}

	to {
		margin-top: 0;
		opacity: 1
	}
}

input,
textarea {
	width: 70%;
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0
}

.referenceInputLabel label {
	width: 80%;
	text-align: left;
	padding: 5px
}

.inputLabel label {
	width: 80%;
	text-align: left;
	padding: 5px
}

.emailsAddedContainer {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
	align-items: flex-start;
	margin-left: 8%;
	margin-top: 10px;
	margin-bottom: 10px;
	overflow-x: auto;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 15px;
	width: fit-content;
	max-width: 80%;
	padding: 5px 15px 5px 0;
	padding: 10px
}

.inputLabelNotification {
	display: flex;
	flex-direction: row;
	width: 100%;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 5px
}

.inputLabelNotificationInner {
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: flex-end;
	align-items: center;
	margin-bottom: 5px
}

.inputLabelNotificationInner label {
	width: 80%;
	text-align: left;
	padding: 0
}

.inputButtonContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 85%
}

.inputButtonContainer button {
	padding: 10px;
	background-color: #33f18a;
	box-shadow: rgba(0, 0, 0, .05) 0 1px 5px;
	border-radius: 0 15px 15px 0;
	cursor: pointer;
	transition-duration: .5s;
	color: #fff;
	font-size: 15px;
	border: .25px solid #b3b3b3;
	border-left: none
}

.inputButtonContainer button:hover {
	background-color: #30df9c;
	transition-duration: .5s
}

.notification-input-style {
	padding: 10px;
	font-size: 15px;
	border: .25px solid rgba(0, 0, 0, .336);
	border-radius: 15px 0 0 15px;
	outline: 0
}

@keyframes itemDropdown {
	from {
		margin-top: -3%
	}

	to {
		margin-top: 0
	}
}

.addedItems {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: fit-content;
	height: 25px;
	animation: itemDropdown;
	animation-duration: .5s
}

.removeItemButton {
	margin-left: 10px;
	margin-top: 0;
	cursor: pointer;
	border: none;
	border-radius: 15px;
	background-color: #32ccfe;
	color: #fff;
	transition-duration: .5s
}

.removeItemButton:hover {
	background-color: #2db4e0;
	color: #d4d3d3;
	transition-duration: .5s
}

.buttonContainer {
	margin-top: 15px;
	margin-bottom: 15px;
	width: 100%;
	text-align: center
}

.saveButton {
	padding-top: 10px;
	padding-bottom: 10px;
	padding-right: 15px;
	padding-left: 15px;
	margin-right: 5px;
	border: none;
	border-radius: 50px;
	cursor: pointer;
	font-size: 12px;
	transform: scale(.97);
	color: #fff;
	border: 1px solid #fe804d;
	background-color: #fe804d;
	transition-duration: .25s
}

.saveButton:hover {
	background-color: #e87446;
	color: #fff;
	transition-duration: .25s
}

.shipButton:hover {
	background-color: #2bb2df;
	transition-duration: .25s
}

.shipButton {
	padding-top: 10px;
	padding-bottom: 10px;
	padding-right: 45px;
	padding-left: 45px;
	margin-left: 5px;
	border: none;
	border-radius: 50px;
	cursor: pointer;
	font-size: 20px;
	transform: scale(.97);
	transition-duration: .25s;
	color: #fff;
	background-color: #32ccfe
}

.finalContainer {
	display: flex;
	flex-direction: column;
	margin-top: 35px;
	padding: 15px;
	box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
	background-color: #fff;
	border-radius: 25px;
	animation: containerAnimateLeft .4s
}

.refreshButton {
	color: #fff;
	background-color: #32ccfe;
	border: none;
	border-radius: 5px;
	padding: 5px 10px;
	margin-bottom: 15px;
	margin-right: 5px;
	font-size: 10px;
	transition-duration: .4s ease;
	cursor: pointer
}

.refreshButton:hover {
	background-color: #2bb2df;
	transition-duration: .5s
}

.getLabelButton:hover {
	background-color: #2bb2df;
	transition-duration: .5s
}

.getLabelButton {
	color: #fff;
	background-color: #32ccfe;
	border: none;
	border-radius: 5px;
	padding: 10px 35px;
	transition-duration: .4s ease;
	cursor: pointer;
	font-size: 12px
}

.getLabelButton-container {
	margin-bottom: 10px;
	width: 100%;
	display: flex;
	justify-content: flex-start
}

.pdfViewer {
	border-radius: 15px;
	margin-bottom: 15px;
}

.st0 {
	fill: none;
	stroke: #000;
	stroke-width: 8;
	stroke-miterlimit: 10
}

.st1 {
	fill: none;
	stroke: #000;
	stroke-width: 12;
	stroke-linecap: round;
	stroke-linejoin: round
}

.cls-1-alt {
	fill: none;
	stroke: #000;
	stroke-miterlimit: 10;
	stroke-width: 8px
}

.cls-1 {
	fill: none;
	stroke: #000;
	stroke-miterlimit: 10;
	stroke-width: 8px
}

.cls-2 {
	fill: none;
	stroke: #000;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-width: 12px
}

.cls-2-alt {
	stroke: #000;
	fill: none;
	stroke-linecap: round;
	stroke-linejoin: round;
	stroke-width: 11px
}

.howContainerInner {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly
}

@keyframes showDetails {
	from {
		margin-top: -50px;
		opacity: 0
	}

	to {
		margin-top: 0;
		opacity: 1
	}
}

.detailsContainer,
.howContainer,
.whereContainer {
	margin-top: 10px;
	border: 1px solid #f8f8f8;
	background-color: #f8f8f8;
	border-radius: 25px;
	padding: 15px 5px
}

.address-svg-container {
	width: 100%;
	display: flex;
	justify-content: center
}

.stateInput {
	width: 75%;
	padding: 10px;
	font-size: 15px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0
}

.stateInput-container {
	width: 50%;
	padding: 10px;
	border: 1px solid rgba(0, 0, 0, .336);
	border-radius: 15px;
	outline: 0;
	margin-left: auto
}

.pdfSupportMessage {
	display: none
}

.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.loading-overlay {
  /* position: absolute; */
  margin-bottom: 5px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8); /* Light overlay effect */
  /* z-index: 10; */
}

.pdf-embed {
  width: 100%;
  height: 100%;
}

.show-terms-conditions-link {
	color: #32ccfe;
	cursor: pointer
}

.address-book-table-container {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
	z-index: 10
}

.address-book-table-container h2 {
	text-align: left;
	margin: 0
}

.address-book-table-inner {
	padding: 10px;
	background-color: #fff;
	border-radius: 25px;
	height: fit-content;
	margin-right: 5%;
	margin-left: 5%;
	margin-top: 5%;
	overflow-y: auto;
	box-shadow: 0 0 20px rgba(0, 0, 0, .3);
	animation: address-book-animate .5s ease;
	flex-basis: 60%
}

.contracted-delivery-table {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
	z-index: 10
}

.contracted-delivery-table-inner {
	background-color: #fff;
	padding: 10px;
	flex-basis: 60%;
	animation: address-book-animate .5s ease;
	border-radius: 25px;
	height: fit-content;
	max-height: 60vh;
	margin-top: 5%;
	box-shadow: 0 0 20px rgba(0, 0, 0, .3)
}

.close-search-address-book {
	display: flex;
	justify-content: flex-end
}

.close-shipment-info-container {
	display: flex;
	justify-content: flex-end
}

.close-shipment-info {
	width: 30px;
	height: 30px;
	margin-right: 5%;
	margin-top: 5px;
	transition-duration: .5s;
	cursor: pointer
}

.close-shipment-info:hover {
	transition-duration: .5s;
	border-radius: 999px;
	background-color: #e4e4e4
}

input[type=checkbox] {
	-webkit-appearance: none;
	appearance: none;
	background-color: #f5f5f5;
	/* margin: 0; */
	font: inherit;
	color: #33f18a;
	width: 1.05em;
	height: 1.05em;
	border: .15em solid #33f18a;
	border-radius: .15em;
	transform: translateY(-.075em);
	display: grid;
	place-content: center
}

input[type=checkbox]::before {
	content: "";
	width: .65em;
	height: .65em;
	clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0, 43% 62%);
	transform: scale(0);
	transform-origin: bottom left;
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=checkbox]:checked::before {
	transform: scale(1)
}

.checkBox{
    width: 20px;
    cursor: pointer;
    transition-duration: .2s;
}

.checkBox:hover{
    background: #dfdfdf;
    transition-duration: .2s;
}

input[type=radio] {
	-webkit-appearance: none;
	appearance: none;
	background-color: var(--form-background);
	margin: 0;
	font: inherit;
	color: #33f18a;
	width: 1.15em;
	height: 1.15em;
	border: .15em solid #33f18a;
	border-radius: 50%;
	transform: translateY(-.075em);
	display: grid;
	place-content: center;
	padding: 2px;
	margin-left: 10px
}

input[type=radio]::before {
	content: "";
	width: .65em;
	height: .65em;
	border-radius: 50%;
	transform: scale(0);
	transition: 120ms transform ease-in-out;
	box-shadow: inset 1em 1em var(--form-control-color);
	background-color: CanvasText
}

input[type=radio]:checked::before {
	transform: scale(1);
	background-color: #33f18a
}

@media only screen and (max-width:600px) {
	.service-text {
		font-size: 8px
	}

	.shipmentid-text {
		font-size: 10px
	}

	.col-2 {
		font-size: 12px
	}

	.contracted-delivery-table-inner {
		flex-basis: 90%
	}

	.create-shipment {
		margin-left: 15px;
		margin-right: 15px;
		max-width: none
	}
}

@media screen and (max-width:500px) {
	.pdfSupportMessage {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 10px
	}
}

@media screen and (max-width:1000px) {
	.confirmContainerInner1 {
		margin: 7.5px
	}

	.confirmContainerInner2 {
		margin: 7.5px
	}

	.weight-container {
		margin: 7.5px
	}

	.package-details-container {
		flex-direction: column
	}

	.address-book-table-inner {
		flex-basis: 90%
	}

	.container {
		width: 90%
	}

	.swap-button-inner {
		transform: rotate(90deg)
	}

	.address-container {
		width: 100%;
		display: flex;
		flex-direction: column
	}

	.address-container-1 {
		width: 100%
	}

	.address-container-2 {
		width: 100%;
		animation: containerAnimateLeft .4s
	}

	.address-container.pickup-page {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center
	}

	.address-container-1.pickup-page {
		width: 85%
	}

	.address-container-2.pickup-page {
		width: 85%
	}

	.input-container label {
		text-align: left
	}

	.notifications-container {
		width: 100%;
		display: flex;
		flex-direction: column
	}

	.notifications-container-0,
	.notifications-container-1 {
		width: 100%
	}

	.notifications-container-2 {
		width: 100%;
		padding-top: 15px;
		animation: containerAnimateLeft .4s
	}

	.notificationHeader {
		margin-top: 10px;
		margin-left: 10%
	}

	.referenceHeader {
		margin-left: 10%
	}

	.inputButtonContainer {
		justify-content: flex-start;
		width: 80%
	}

	.confirmContainerInner {
		display: flex;
		flex-direction: row;
		margin: 0
	}

	.confirm-container-address {
		display: flex;
		flex-direction: column
	}

	.confirmContainerInner2 {
		animation: containerAnimateLeft .4s
	}

	.confirm-container-main {
		justify-content: flex-start
	}

	.weight-container {
		text-align: left;
		overflow: auto
	}

	.inputLabel p {
		cursor: pointer;
		font-size: 12px
	}

	.inputLabel {
		width: 100%
	}

	input {
		width: 70%
	}

	.address-book-button-container {
		width: 100%
	}

	.address-book-button-inner {
		width: 100%
	}

	.weightMainContainer {
		width: fit-content;
		justify-content: center;
		align-items: center;
		margin-left: 10%;
		box-shadow: rgba(0, 0, 0, .164) 0 1px 10px;
		background-color: #fff
	}

	.addPackageButton {
		display: flex;
		margin-left: 10%
	}

	.weightInputContainer {
		width: 100%;
		background-color: transparent
	}

	.emailsAddedContainer {
		margin-left: 10%;
		max-width: 60%
	}

	.emailsAddedContainer p {
		padding-left: 10px
	}

	.circle {
		width: 10vw;
		height: 10vw
	}

	.details,
	.how,
	.where {
		font-size: 2.5vw
	}

	.confirm {
		font-size: 2.5vw
	}

	.confirmContainerInner label {
		padding: 0
	}

	.howContainerInner {
		flex-direction: column
	}
}

@media screen and (max-width:700px) {
	.address-book-table-container {
		width: 100%
	}

	.weight-container {
		text-align: left
	}
}

@media screen and (max-width:650px) {
	.confirmLabelContainer {
		flex-direction: column;
		align-items: flex-start
	}

	.confirmContainerInner {
		flex-direction: column
	}
}

@media screen and (max-width:585px) {
	.address-container-1.pickup-page {
		width: 100%
	}

	.address-container-2.pickup-page {
		width: 100%
	}
}
</style>